/* Source: src/mt-includes/widgets/accordion/src/frontend/accordion.frontend.js*/
angular.module('website.widget.accordion').directive('motoWidgetAccordion', [
    'website.WidgetsRepository',
    function(WidgetsRepository) {
        var animationPreferences = {
            startAnimation: 'onArriving'
        };

        return {
            restrict: 'C',
            scope: true,
            compile: function($element) {
                var thisWidget = WidgetsRepository.registry($element);

                return {
                    pre: function($scope) {
                        thisWidget.setScope($scope);
                    },
                    post: function() {
                        $element.motoAccordion({
                            onOpening: function(item) {
                                thisWidget.getChild(item.id).onArriving(animationPreferences);
                            },
                            onOpened: function(item) {
                                thisWidget.getChild(item.id).onArrived(animationPreferences);
                            },
                            onClosing: function(item) {
                                thisWidget.getChild(item.id).onVanishing();
                            },
                            onClosed: function(item) {
                                thisWidget.getChild(item.id).onVanished();
                            }
                        });
                    }
                };
            }
        };
    }]);
